import { render } from "./UploadDropTarget.vue?vue&type=template&id=2a31b0f5"
import script from "./UploadDropTarget.vue?vue&type=script&lang=ts"
export * from "./UploadDropTarget.vue?vue&type=script&lang=ts"
script.render = render

export default script